import { Routes, Route } from "react-router-dom";

import ContractsListSection from "./sections/contractsListSection";
import ContractsInfoSection from "./sections/contractsInfoSection";

function ContractsApp() {
    const data = JSON.parse(localStorage.getItem("userData") as string);

    return (
        <Routes>
            {!data.isCustomer && (
                <>
                    <Route path="/" element={<ContractsListSection />} />
                    <Route path='/:id/info' element={<ContractsInfoSection />} />
                </>
            )}
        </Routes>
    );
}

export default ContractsApp;
